import React, { Component, useRef, useEffect } from "react";

import Clock from "../sketches/Clock.jsx";

import Responsive from "../layouts/Responsive.jsx";
import BasicLayout from "../layouts/Basic.jsx";
import Title from "../components/Title";
import Pages from "../components/Pages.jsx";

import gsap from "gsap";
import { Draggable } from "gsap/all";

const Tenthirty = () => {
  gsap.registerPlugin(Draggable);
  const drag = useRef();

  useEffect(() => {
    let ctx = gsap.context(() => {
      // use scoped selectors
      Draggable.create(".img-wrapper .m-text", {});

      return () => ctx.revert();
    }, drag);

    // let random = gsap.utils.random;
    let width = window.innerWidth * 0.65;
    let height = window.innerHeight * 0.65;

    gsap.to(".img-wrapper .m-text", {
      x: "random(-200, 200)",
      y: "random(-200, 200)",
      ease: "elastic",
      duration: 1,
      // repeat: -1,
      // repeatRefresh: true,
    });

    gsap.fromTo(
      ".img-wrapper .m-text",
      {
        scale: 0.9,
        ease: "back",
        delay: 1,

        repeat: -1,
        repeatRefresh: true,
      },
      {
        duration: 1,
        scale: 1,
        // ease: "power1",
        delay: 1,
        repeat: -1,
        repeatRefresh: true,
      }
    );
  }, []);

  return (
    <>
      <Responsive />
      <div className="book-wrapper">
        <div className="left-con">
          {/* <Title /> */}
          <div className="contents-wrapper">
            <div className="canvas-wrapper">
              <Clock />
            </div>
            <div className="element-wrapper">
              <div className="text-wrapper" ref={drag}>
                <div className="img-wrapper">
                  <p className="m-text">It</p>
                  {/* <img src={T1} alt="It" /> */}
                </div>
                <div className="img-wrapper">
                  <p className="m-text">must</p>
                  {/* <img src={T2} alt="must" /> */}
                </div>
                <div className="img-wrapper">
                  <p className="m-text">have</p>
                  {/* <img src={T3} alt="have" /> */}
                </div>
                <div className="img-wrapper">
                  <p className="m-text">been</p>
                  {/* <img src={T4} alt="been" /> */}
                </div>
                <div className="img-wrapper">
                  <p className="m-text">between</p>
                  {/* <img src={T5} alt="between" /> */}
                </div>
                <div className="img-wrapper">
                  <p className="m-text">six</p>
                  {/* <img src={T6} alt="six" /> */}
                </div>
                <div className="img-wrapper">
                  <p className="m-text">and</p>
                  {/* <img src={T7} alt="and" /> */}
                </div>
                <div className="img-wrapper">
                  <p className="m-text">seven</p>
                  {/* <img src={T8} alt="seven" /> */}
                </div>
                <div className="img-wrapper">
                  <p className="m-text">in</p>
                  {/* <img src={T9} alt="in" /> */}
                </div>
                <div className="img-wrapper">
                  <p className="m-text">the</p>
                  {/* <img src={T10} alt="the" /> */}
                </div>
                <div className="img-wrapper">
                  <p className="m-text">morning</p>
                  {/* <img src={T11} alt="morning" /> */}
                </div>
              </div>
            </div>
          </div>
        </div>
        <BasicLayout />
      </div>
    </>
  );
};

export default Tenthirty;
